/** @format */

export enum Routes {
  home = "/",
  login = "/login",
  search = "/search",
  form = "/detail/:idCliente",
}
